module.exports = __webpack_public_path__ + "lp/img/recording_light.fe40914c.svg";